import { render, staticRenderFns } from "./Reassign.vue?vue&type=template&id=59a6b2f2&"
import script from "./Reassign.vue?vue&type=script&lang=js&"
export * from "./Reassign.vue?vue&type=script&lang=js&"
import style0 from "./Reassign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports